export default "__VITE_ASSET__DPdWiHvd__"